


































import { fromByteArray } from 'base64-js'
import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'

import { ErrorNode } from '../logic/ErrorNode'

@Component
export default class ErrorNodeSidebar extends Vue {
  @Prop() node!: ErrorNode

  get errorText(): string {
    const error = `boardId: ${ this.$route.params.id }
    \n\n config-key: ${ this.$route.query.flow_key }
    \n\n node-data: ${ JSON.stringify(this.node.data) }
    `

    // eslint-disable-next-line compat/compat
    const bytes = new (TextEncoder)().encode(error)
    return fromByteArray(bytes)
  }

  copyText(): void {
    try {
      // eslint-disable-next-line compat/compat
      navigator.clipboard.writeText(this.errorText)

      this.$notification.success({
        message: this.$t('success').toString(),
        description: this.$t('file_uploader_limit_alert_text').toString(),
        placement: 'bottomRight',
        class: 'successNotification',
      })

    } catch (error) {
      this.$notification.error({
        message: this.$t('error').toString(),
        description: error as string,
        placement: 'bottomRight',
        class: 'successNotification',
      })
    }
  }
}
